import React, { useCallback, useContext, useEffect } from 'react';
import Checkbox from 'components/Inputs/Checkbox';
import { FindAndReplaceContext } from './FindAndReplace';
import { FindAndReplace } from '../types';
import { useGetMetric } from '../../../../GoalShow/useGoalData';

interface FindAndReplaceCheckboxType {
  type: FindAndReplace.AffectedContentType;
  itemId: string;
  report?: FleetOps.MetricReportUsage;
  dashboardGadget?: FleetOps.DashboardGadgetUsage;
  board?: PerformanceBoardTypes.Board | Board;
  goal?: GeneralGoal;
  scorecard?: Scorecards.Scorecard;
  compoundMetric?: Metrics.CompoundMetric;
  performanceConfiguration?: { id: string; name: string };
  chartDefinition?: { id: string; name: string };
}

const FindAndReplaceCheckbox = ({
  item,
}: {
  item: FindAndReplaceCheckboxType;
}) => {
  const getMetric = useGetMetric();
  const { updateById, replaceMetricId } = useContext(FindAndReplaceContext);
  const [checked, setChecked] = React.useState(true);
  const replaceMetric = getMetric(replaceMetricId);

  useEffect(() => {
    if (
      item.type === 'performanceConfigurations' ||
      (item.type === 'compoundMetrics' && replaceMetric?.type === 'compound')
    ) {
      setChecked(false);
    }
  }, [item, replaceMetric]);

  const handleToggle = useCallback(
    (isChecked: boolean) => {
      setChecked(isChecked);
      updateById(item.itemId, isChecked ? 'add' : 'remove', item.type);
    },
    [item, updateById],
  );

  return (
    <>
      <Checkbox
        testId={`find-replace-checkbox-${item.itemId}`}
        isDisabled={
          (item.type === 'compoundMetrics' &&
            replaceMetric?.type === 'compound') ||
          item.type === 'performanceConfigurations'
        }
        isChecked={checked}
        onToggled={handleToggle}
      />
      <span style={{ paddingRight: 10 }}></span>
    </>
  );
};

const Gate = ({ item }: { item: FindAndReplaceCheckboxType }) => {
  const { isFindAndReplaceFlowActive } = useContext(FindAndReplaceContext);
  if (!isFindAndReplaceFlowActive) {
    return null;
  }

  return <FindAndReplaceCheckbox item={item} />;
};

export default Gate;
